const JiminnyIcon = ({ size = 25 }: { size?: number | string }) => (
  <img
    src="/JiminnyLogo.png"
    alt="Jiminny"
    width={size}
    height={size}
    style={{ objectFit: 'contain' }}
  />
);

export default JiminnyIcon;
